import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    userInfoFlag: false,
    token: "",
    username: "",
    modalFlag: false,
    isLogin: false, // 登录框是否显示

    phoneNumber: "",
    smsCode: "",
    passwordNumber: "",
  },
  mutations: {
    //控制Login组件input框v-model的值
    handlePhoneNumber(state, payload) {
      state.phoneNumber = payload
    },
    handleSmsCode(state, payload) {
      state.smsCode = payload
    },
    handlePasswordNumber(state, payload) {
      state.passwordNumber = payload
    },
  },
  actions: {},
  modules: {}
})
